import { css, cx } from 'emotion';
import {
	darkGrey,
	orange,
	aqua,
	pink,
	purple,
	burnedOrange,
	desktopMaxWidthBreakpoint,
	headingLarge,
	headingMedium,
	textBlock,
	cardSection,
	headingXLarge,
	headingSmallLight,
	label,
	museo500,
	museo900,
	tabletLandscapeMaxWidthBreakpoint,
	tabletPortraitMinWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	mobileMinWidthBreakpoint,
	mobileMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const titleStyle = cx(
	headingLarge,
	css({
		marginBottom: '24px',
	})
);

export const attendTitleStyle = cx(
	headingLarge,
	css({
		marginBottom: '24px',
    color: orange
	})
);

export const textStyle = cx(
	textBlock,
	css({
		'& p': {
			maxWidth: '800px',
		},
	})
);

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
	overflowX: 'hidden',
});

export const attendStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',

  display: 'flex',
  '> img': {
    'margin-top': '-120px',
    'margin-left': '24px',
    'margin-right': '24px',
  }
});

export const videoSection = (color) => css({
  background: color,
});

export const videoDiv = cx(
  headingLarge,
  innerWrapperStyle,
  css({
    color: 'white',
    padding: '64px 20px',
    marginBottom: '480px',
    position: 'relative',
    overflowX: 'visible',
    paddingBottom: '150px',
    '> iframe': {
      position: 'absolute',
      right: '0',
    },
    '> div': {
      marginBottom: '1em',
    }
  })
);

export const cardsStyle = css({
  position: 'relative',
  zIndex: '1',
  marginTop: '-146px',
});

export const ctaStyle = css({
  ...museo900,
  color: '#000',
  margin: '0 0 10px',
  position: 'relative',
  zIndex: '1',
  [`@media (min-width: ${mobileMinWidthBreakpoint}px)`]: {
    fontSize: '16px',
    lineHeight: '19px',
  },
  [`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
    fontSize: '18px',
    lineHeight: '22px',
  },
});

export const resourceWrapper = css({
  width: '240px',
  margin: '0 12px',
})



// WEBPACK FOOTER //
// ./src/page-styles/medicare/index.js